"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "settings-page"
  }, [_c("div", {
    staticClass: "settings-card"
  }, [_vm._m(0), _c("el-form", {
    ref: "formData",
    staticClass: "modern-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-position": "top"
    }
  }, [_c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "section-title"
  }, [_vm._v(" Charge Configuration ")]), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Transportation Charges (%)",
      prop: "transportCharges"
    }
  }, [_c("el-input-number", {
    staticClass: "modern-input",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      precision: 2,
      step: 1,
      min: 0,
      max: 100,
      "controls-position": "right"
    },
    model: {
      value: _vm.formData.transportCharges,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "transportCharges", $$v);
      },
      expression: "formData.transportCharges"
    }
  }), _c("help-text", {
    attrs: {
      content: "Percentage of order amount added as transportation charges"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Packaging Charges (%)",
      prop: "packagingCharges"
    }
  }, [_c("el-input-number", {
    staticClass: "modern-input",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      precision: 2,
      step: 1,
      min: 0,
      max: 100,
      "controls-position": "right"
    },
    model: {
      value: _vm.formData.packagingCharges,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "packagingCharges", $$v);
      },
      expression: "formData.packagingCharges"
    }
  }), _c("help-text", {
    attrs: {
      content: "Percentage of order amount added as packaging charges"
    }
  })], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "section-title"
  }, [_vm._v(" General Settings ")]), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Next Quotation Number",
      prop: "nextQuotation"
    }
  }, [_c("el-input", {
    staticClass: "modern-textbox",
    model: {
      value: _vm.formData.nextQuotation,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "nextQuotation", $$v);
      },
      expression: "formData.nextQuotation"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Working Hours",
      prop: "workingHours"
    }
  }, [_c("el-time-picker", {
    staticClass: "modern-textbox",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "is-range": "",
      "range-separator": "To",
      "start-placeholder": "Start time",
      "end-placeholder": "End time",
      format: "HH:mm",
      "value-format": "HH:mm"
    },
    model: {
      value: _vm.workingHoursRange,
      callback: function ($$v) {
        _vm.workingHoursRange = $$v;
      },
      expression: "workingHoursRange"
    }
  })], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "section-title"
  }, [_vm._v(" Support Information ")]), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Support Email",
      prop: "supportEmail"
    }
  }, [_c("el-input", {
    staticClass: "modern-textbox",
    model: {
      value: _vm.formData.supportEmail,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "supportEmail", $$v);
      },
      expression: "formData.supportEmail"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Support Contact",
      prop: "supportContact"
    }
  }, [_c("el-input", {
    staticClass: "modern-textbox",
    attrs: {
      maxlength: "12",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.supportContact,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "supportContact", $$v);
      },
      expression: "formData.supportContact"
    }
  })], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "form-section"
  }, [_c("div", {
    staticClass: "section-title"
  }, [_vm._v(" Default Content ")]), _c("el-form-item", {
    attrs: {
      label: "Default Terms And Conditions",
      prop: "termsAndConditions"
    }
  }, [_c("div", {
    staticClass: "editor-wrapper"
  }, [_c("editor", {
    attrs: {
      "api-key": "no-api-key",
      init: {
        height: 500,
        plugins: ["lists link image paste help wordcount preview table | code"],
        toolbar: "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help"
      }
    },
    model: {
      value: _vm.formData.termsAndConditions,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "termsAndConditions", $$v);
      },
      expression: "formData.termsAndConditions"
    }
  })], 1), _c("help-text", {
    attrs: {
      content: "Default Terms applied to new quotations"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Default Quotation Additional Note",
      prop: "quotationAdditionalNote"
    }
  }, [_c("div", {
    staticClass: "editor-wrapper"
  }, [_c("editor", {
    attrs: {
      "api-key": "no-api-key",
      init: {
        height: 500,
        plugins: ["lists link image paste help wordcount preview table | code"],
        toolbar: "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help"
      }
    },
    model: {
      value: _vm.formData.quotationAdditionalNote,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "quotationAdditionalNote", $$v);
      },
      expression: "formData.quotationAdditionalNote"
    }
  })], 1), _c("help-text", {
    attrs: {
      content: "This note appears in quotation PDFs"
    }
  })], 1)], 1), _c("div", {
    staticClass: "form-footer"
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "save-btn",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" Save Settings ")])], 1)])], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "settings-header"
  }, [_c("h2", [_vm._v("Quotation Settings")]), _c("p", [_vm._v("Manage default quotation configuration")])]);
}];
render._withStripped = true;